// Company icons
import BLAST from '../img/logos_currency/Blast.png';
import ETHEREUM from '../img/logos_currency/Ether@4x.png';
import CARDANO from '../img/logos_currency/Cardano.png';
import MATIC from '../img/logos_currency/MATIC@4x.png';
import BNB from '../img/logos_currency/BNB@4x.png';
import ARBITRUM from '../img/logos_currency/Arbitrum@4x.png';
import ARBITRUM_NOVA from '../img/logos_currency/ArbitrumNova.png';
import LINEA from '../img/logos_currency/Linea--alt.png';
import AVALANCHE from '../img/logos_currency/Avalanche@4x.png';
import SOLANA from '../img/logos_currency/Solana@4x.png';
import BASE from '../img/logos_currency/Base.png';
import MANTLE from '../img/logos_currency/Mantle.png';
import MODE from '../img/logos_currency/Mode.png';
import MONAD from '../img/logos_currency/Monad.png';
import OPTIMISM from '../img/logos_currency/Optimism@4x.png';
import ZKSYNC_ERA from '../img/logos_currency/ZkSyncEra.png';
import ZORA from '../img/logos_currency/Zora.svg';
import ARWEAVE from '../img/logos_currency/Arweave@4x.png';
import COSMOS_HUB from '../img/logos_currency/CosmosHub@4x.png';
import OSMOSIS from '../img/logos_currency/Osmosis.png';
import RIPPLE from '../img/logos_currency/Ripple.png';
import STARKNET from '../img/logos_currency/Starknet.png';
import TRON from '../img/logos_currency/Tron.png';
import SCROLL from '../img/logos_currency/Scroll.png';
import STELLAR from '../img/logos_currency/Stellar.png';
import STORY from '../img/logos_currency/Story.png';
import SUI from '../img/logos_currency/Sui.png';
import SYNDICATE from '../img/logos_currency/Syndicate.png';
import UNICHAIN from '../img/logos_currency/Unichain.png';
import BERACHAIN from '../img/logos_currency/Berachain.png';
import APECHAIN from '../img/logos_currency/Apechain.png';
import DYDX from '../img/logos_currency/dYdX.png';
import GNOSIS from '../img/logos_currency/Gnosis.png';
import ABSTRACT from '../img/logos_currency/Abstract.jpg';
import NEUTRON from '../img/logos_currency/Neutron.png';
import SEI from '../img/logos_currency/Sei.png';
import SHAPE from '../img/logos_currency/Shape.png';
import NOBLE from '../img/logos_currency/Noble.jpg';
import FLOW from '../img/logos_currency/Flow.png';
import HYPERLIQUID from '../img/logos_currency/Hyperliquid.png';
import ROBINHOOD from '../img/logos_currency/Robinhood.png';
import { AccountReference } from '@/api/__types/accounts.types';
import {
  validateArweaveAddress,
  validateAvalancheAddress,
  validateCardanoAddress,
  validateCosmosAddress,
  validateDydxAddress,
  validateEthereumAddress,
  validateNeutronAddress,
  validateNobleAddress,
  validateFlowAddress,
  validateRippleAddress,
  validateSeiAddress,
  validateShapeAddress,
  validateSolanaAddress,
  validateStarknetAddress,
  validateStellarAddress,
  validateSuiAddress,
  validateTronAddress,
} from './addresses';

// Types
export type ChainId =
  | 'abstract'
  | 'apechain'
  | 'arbitrum-nova'
  | 'arbitrum-one'
  | 'arweave'
  | 'avalanche'
  | 'base'
  | 'berachain'
  | 'binance-smart-chain'
  | 'blast'
  | 'cardano'
  | 'cosmoshub-4'
  | 'dydx-mainnet-1'
  | 'ethereum'
  | 'flow'
  | 'hyperliquid'
  | 'linea'
  | 'mantle'
  | 'mode'
  | 'monad'
  | 'neutron-1'
  | 'noble-1'
  | 'optimism'
  | 'osmosis-1'
  | 'pacific-1'
  | 'polygon'
  | 'ripple'
  | 'robinhood'
  | 'scroll'
  | 'sei-v2'
  | 'shape'
  | 'story'
  | 'solana'
  | 'starknet'
  | 'stellar'
  | 'sui'
  | 'syndicate'
  | 'syndicate-commons'
  | 'tronscan'
  | 'unichain'
  | 'xdai'
  | 'zksync-era'
  | 'zora';

export interface IChain {
  name: string;
  id: ChainId;
  image: string;
  validateAddress: (address: string) => boolean;
}

export const ChainsById: Record<ChainId, IChain> = {
  ethereum: {
    name: 'Ethereum',
    id: 'ethereum',
    image: ETHEREUM,
    validateAddress: validateEthereumAddress,
  },
  cardano: {
    name: 'Cardano',
    id: 'cardano',
    image: CARDANO,
    validateAddress: validateCardanoAddress,
  },
  polygon: {
    name: 'Polygon',
    id: 'polygon',
    image: MATIC,
    validateAddress: validateEthereumAddress,
  },
  'binance-smart-chain': {
    name: 'Binance Smart Chain',
    id: 'binance-smart-chain',
    image: BNB,
    validateAddress: validateEthereumAddress,
  },
  'arbitrum-one': {
    name: 'Arbitrum',
    id: 'arbitrum-one',
    image: ARBITRUM,
    validateAddress: validateEthereumAddress,
  },
  'arbitrum-nova': {
    name: 'Arbitrum Nova',
    id: 'arbitrum-nova',
    image: ARBITRUM_NOVA,
    validateAddress: validateEthereumAddress,
  },
  linea: {
    name: 'Linea',
    id: 'linea',
    image: LINEA,
    validateAddress: validateEthereumAddress,
  },
  solana: {
    name: 'Solana',
    id: 'solana',
    image: SOLANA,
    validateAddress: validateSolanaAddress,
  },
  avalanche: {
    name: 'Avalanche',
    id: 'avalanche',
    image: AVALANCHE,
    validateAddress: validateAvalancheAddress,
  },
  base: {
    name: 'Base',
    id: 'base',
    image: BASE,
    validateAddress: validateEthereumAddress,
  },
  mantle: {
    name: 'Mantle',
    id: 'mantle',
    image: MANTLE,
    validateAddress: validateEthereumAddress,
  },
  mode: {
    name: 'Mode',
    id: 'mode',
    image: MODE,
    validateAddress: validateEthereumAddress,
  },
  optimism: {
    name: 'Optimism',
    id: 'optimism',
    image: OPTIMISM,
    validateAddress: validateEthereumAddress,
  },
  'zksync-era': {
    name: 'zkSync Era',
    id: 'zksync-era',
    image: ZKSYNC_ERA,
    validateAddress: validateEthereumAddress,
  },
  zora: {
    name: 'Zora',
    id: 'zora',
    image: ZORA,
    validateAddress: validateEthereumAddress,
  },
  arweave: {
    name: 'Arweave',
    id: 'arweave',
    image: ARWEAVE,
    validateAddress: validateArweaveAddress,
  },
  'cosmoshub-4': {
    name: 'Cosmos Hub',
    id: 'cosmoshub-4',
    image: COSMOS_HUB,
    validateAddress: validateCosmosAddress,
  },
  'osmosis-1': {
    name: 'Osmosis',
    id: 'osmosis-1',
    image: OSMOSIS,
    validateAddress: validateCosmosAddress,
  },
  'dydx-mainnet-1': {
    name: 'dYdX',
    id: 'dydx-mainnet-1',
    image: DYDX,
    validateAddress: validateDydxAddress,
  },
  'neutron-1': {
    name: 'Neutron',
    id: 'neutron-1',
    image: NEUTRON,
    validateAddress: validateNeutronAddress,
  },
  ripple: {
    name: 'Ripple',
    id: 'ripple',
    image: RIPPLE,
    validateAddress: validateRippleAddress,
  },
  blast: {
    name: 'Blast',
    id: 'blast',
    image: BLAST,
    validateAddress: validateEthereumAddress,
  },
  scroll: {
    name: 'Scroll',
    id: 'scroll',
    image: SCROLL,
    validateAddress: validateEthereumAddress,
  },
  story: {
    name: 'Story',
    id: 'story',
    image: STORY,
    validateAddress: validateEthereumAddress,
  },
  starknet: {
    name: 'Starknet',
    id: 'starknet',
    image: STARKNET,
    validateAddress: validateStarknetAddress,
  },
  stellar: {
    name: 'Stellar',
    id: 'stellar',
    image: STELLAR,
    validateAddress: validateStellarAddress,
  },
  syndicate: {
    name: 'Syndicate',
    id: 'syndicate',
    image: SYNDICATE,
    validateAddress: validateEthereumAddress,
  },
  'syndicate-commons': {
    name: 'Syndicate Commons',
    id: 'syndicate-commons',
    image: SYNDICATE,
    validateAddress: validateEthereumAddress,
  },
  tronscan: {
    name: 'Tron',
    id: 'tronscan',
    image: TRON,
    validateAddress: validateTronAddress,
  },
  sui: {
    name: 'Sui',
    id: 'sui',
    image: SUI,
    validateAddress: validateSuiAddress,
  },
  unichain: {
    name: 'Unichain',
    id: 'unichain',
    image: UNICHAIN,
    validateAddress: validateEthereumAddress,
  },
  berachain: {
    name: 'Berachain',
    id: 'berachain',
    image: BERACHAIN,
    validateAddress: validateEthereumAddress,
  },
  apechain: {
    name: 'Apechain',
    id: 'apechain',
    image: APECHAIN,
    validateAddress: validateEthereumAddress,
  },
  xdai: {
    name: 'Gnosis',
    id: 'xdai',
    image: GNOSIS,
    validateAddress: validateEthereumAddress,
  },
  abstract: {
    name: 'Abstract',
    id: 'abstract',
    image: ABSTRACT,
    validateAddress: validateEthereumAddress,
  },
  'pacific-1': {
    name: 'Sei',
    id: 'pacific-1',
    image: SEI,
    validateAddress: validateSeiAddress,
  },
  'sei-v2': {
    name: 'Sei EVM',
    id: 'sei-v2',
    image: SEI,
    validateAddress: validateEthereumAddress,
  },
  'noble-1': {
    name: 'Noble',
    id: 'noble-1',
    image: NOBLE,
    validateAddress: validateNobleAddress,
  },
  flow: {
    name: 'Flow',
    id: 'flow',
    image: FLOW,
    validateAddress: validateFlowAddress,
  },
  shape: {
    name: 'Shape',
    id: 'shape',
    image: SHAPE,
    validateAddress: validateShapeAddress,
  },
  hyperliquid: {
    name: 'Hyperliquid',
    id: 'hyperliquid',
    image: HYPERLIQUID,
    validateAddress: validateEthereumAddress,
  },
  monad: {
    name: 'Monad',
    id: 'monad',
    image: MONAD,
    validateAddress: validateEthereumAddress,
  },
  robinhood: {
    name: 'Robinhood Chain',
    id: 'robinhood',
    image: ROBINHOOD,
    validateAddress: validateEthereumAddress,
  },
};

export const chains: IChain[] = Object.values(ChainsById);

// COVALENT supported chains
export const COVALENT_SUPPORTED_CHAINS: ChainId[] = [
  'apechain',
  'arbitrum-nova',
  'arbitrum-one',
  'avalanche',
  'base',
  'berachain',
  'binance-smart-chain',
  'blast',
  'ethereum',
  'linea',
  'mantle',
  'mode',
  'optimism',
  'polygon',
  'robinhood',
  'scroll',
  'sei-v2',
  'unichain',
  'xdai',
  'zksync-era',
  'zora',
];

const getXUsingY = (x: string, y: any, yShouldEqualTo: any) => {
  const chain: any = chains.find((chain: any) => chain[y] === yShouldEqualTo);

  if (chain) {
    return chain[x];
  }

  return null;
};

export const getChainImageUsingName = (name?: string | null) => getXUsingY('image', 'name', name);
export const getChainImageUsingID = (id?: string | null) => getXUsingY('image', 'id', id);
export const getChainNameUsingID = (id: string | null | undefined) => getXUsingY('name', 'id', id);
export const getChainIDUsingName = (name?: string) => getXUsingY('id', 'name', name);

export default function useChains() {
  return {
    chains,
    getImageUsingName: getChainImageUsingName,
    getImageUsingID: getChainImageUsingID,
    getNameUsingID: getChainNameUsingID,
    getIDUsingName: getChainIDUsingName,
  };
}

export const getChainImageUsingAddress = (
  accounts: AccountReference[] | undefined,
  chain?: string,
  address?: string,
  name?: string,
): any => {
  if ((!name && !address) || !chain) {
    return null;
  }

  const matchingAccount = accounts?.find(
    (acc: any) =>
      ((address && acc.address === address) || (name && acc.name === name)) &&
      chain &&
      acc.chain === chain,
  );

  return matchingAccount ? getXUsingY('image', 'id', chain) : null;
};
